'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { isLastUsedAuthenticationStrategy } from '../_utils/auth-last-authentication-strategy';
interface AuthLastUsedButtonWrapProps {
  children: ReactNode;
  className?: string;
  matchStrategy: string;
  strategy: string | null;
}
const floatingBadgeClassName = 'pointer-events-none absolute top-0 right-4 z-10 -translate-y-1/2 rounded-full border border-role-outline-subtle bg-white px-2.5 py-0.5 text-xs font-semibold text-role-on-surface';
export function AuthLastUsedButtonWrap(t0) {
  const $ = _c(11);
  const {
    strategy,
    matchStrategy,
    children,
    className
  } = t0;
  let isLastUsed;
  let t1;
  if ($[0] !== className || $[1] !== matchStrategy || $[2] !== strategy) {
    isLastUsed = isLastUsedAuthenticationStrategy(strategy, matchStrategy);
    t1 = cn("relative w-full overflow-visible", isLastUsed && "pt-3", className);
    $[0] = className;
    $[1] = matchStrategy;
    $[2] = strategy;
    $[3] = isLastUsed;
    $[4] = t1;
  } else {
    isLastUsed = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isLastUsed) {
    t2 = isLastUsed ? <span aria-hidden={true} className={floatingBadgeClassName}>Last used</span> : null;
    $[5] = isLastUsed;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== t1 || $[9] !== t2) {
    t3 = <div className={t1}>{t2}{children}</div>;
    $[7] = children;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}